"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    float: ", ";\n    text-align: left;\n    margin-right: 10px;\n    input {\n        position: absolute;\n        margin-left: -15px;\n        opacity: 0;\n        :checked+label {\n            color: ", ";\n            &:before {\n                box-shadow: ", ";;\n            }\n        }\n        :disabled, :disabled + label {\n            cursor: not-allowed;\n        }\n    }\n    label {\n        position: relative;\n        display: inline-block;\n        padding: 7px 20px 7px 36px;\n        line-height: 26px;\n        font-weight: 300;\n        cursor: pointer;\n        transition: color 80ms cubic-bezier(0.82,.14,.44,.41);\n        font-size: 12px;\n        color: #000;\n        &:before {\n            position: absolute;\n            top: 50%;\n            margin-top: -12px;\n            left: 0;\n            content: \" \";\n            display: inline-block;\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            background: #ededed;\n            border: 0;\n            box-shadow: none;\n            transition: box-shadow 280ms cubic-bezier(0.82,.14,.44,.41);\n        }\n    }\n    &.is-audit {\n        input {\n            :checked+label {\n                color: #549E38;\n                &:before {\n                    box-shadow: none;\n                    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'%3E%3Cpath d='M16.0313 3.83984H14.8025C14.6303 3.83984 14.4668 3.91895 14.3613 4.0543L7.11388 13.2354L3.63868 8.83203C3.58611 8.76528 3.5191 8.71131 3.44269 8.67417C3.36627 8.63703 3.28243 8.61768 3.19747 8.61758H1.96876C1.85099 8.61758 1.78595 8.75293 1.85802 8.84434L6.67267 14.9439C6.89767 15.2287 7.33009 15.2287 7.55685 14.9439L16.142 4.06484C16.2141 3.9752 16.149 3.83984 16.0313 3.83984Z' fill='%23549E38'/%3E%3C/svg%3E\");\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledRadio = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var inline = _ref.inline;
  return inline ? 'left' : 'none';
}, function (_ref2) {
  var activeColor = _ref2.activeColor;
  return activeColor || 'rgb(43 61 79)';
}, function (_ref3) {
  var activeColor = _ref3.activeColor;
  return "0 0 0 2px ".concat(activeColor || 'rgb(43 61 79)', " inset, 0 0 0 6px #ffffff inset, 0 0 0 12px ").concat(activeColor || 'rgb(43 61 79)', " inset, 0 0 0 24px transparent");
});

var RadioComponent = /*#__PURE__*/function (_Component) {
  _inherits(RadioComponent, _Component);

  var _super = _createSuper(RadioComponent);

  function RadioComponent() {
    _classCallCheck(this, RadioComponent);

    return _super.apply(this, arguments);
  }

  _createClass(RadioComponent, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          options = _this$props.options,
          _this$props$input = _this$props.input,
          name = _this$props$input.name,
          value = _this$props$input.value,
          _onChange = _this$props.onChange,
          namePath = _this$props.namePath,
          valuePath = _this$props.valuePath,
          inline = _this$props.inline,
          colors = _this$props.colors,
          disabled = _this$props.disabled;
      return options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          className: _this.props.isAudit ? 'is-audit' : '',
          key: "".concat(name, "-").concat(index),
          inline: inline,
          activeColor: colors.input
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: "".concat(name, "-").concat(index),
          type: "radio",
          onChange: function onChange() {
            return _onChange(option[valuePath]);
          },
          checked: option[valuePath] === value,
          disabled: disabled
        }), /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: "".concat(name, "-").concat(index)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: option[namePath]
          }
        })));
      });
    }
  }]);

  return RadioComponent;
}(_react.Component);

_defineProperty(RadioComponent, "defaultProps", {
  options: [],
  namePath: 'name',
  valuePath: 'id',
  inline: true,
  isAudit: false
});

var Radio = (0, _withFieldWrapper["default"])(RadioComponent);
exports.Radio = Radio;